import React from 'react';
import { isEmpty } from 'lodash';
import Button from '@atlaskit/button';
import Lozenge from '@atlaskit/lozenge';
import { InfoPanel } from '@css-xp/base';
import CrossIcon from '@atlaskit/icon/glyph/cross';
import OfficeBuildingFilledIcon from '@atlaskit/icon/glyph/office-building-filled';
import { CustomPanel } from '@css-xp/ppc-purchase-experience';
import { AddNewProductsWrapper } from '../../../add-new-products';
import { NextBillDateWrapper } from '../../../next-bill-date';
import { NEW_CLOUD_SITE } from '../../../../constants';

export const NewCloudSiteLozenge = () => (
  <Lozenge testId="new-cloud-site" appearance={'new'}>
    {NEW_CLOUD_SITE}
  </Lozenge>
);

const NewCloudSiteLozengeInfo = () => {
  return (
    <InfoPanel
      type="information"
      title="About provisioning"
      message={
        <>
          <p>
            This is a placeholder in case we need to explain that provisioning will take place <br />
            once the order has been submitted.
          </p>
        </>
      }
    />
  );
};

export const ProductLineItem = ({
  cloudSite,
  onRemoveCloudSiteClick,
  selectiveCloudsiteRemovalEnable,
  children,
  cloudSiteId,
  orgName,
  isNetNewCatalogSelectionEnabled = false,
  isUpdatingNextBillDateDisabled = false,
  isV2DesignEnabled = false,
  isExpandedForLineItem = false,
}: {
  cloudSite: string;
  cloudSiteId: string | number;
  onRemoveCloudSiteClick: (_cloudSite: string) => void;
  selectiveCloudsiteRemovalEnable: boolean;
  children: React.ReactNode;
  orgName: string;
  isNetNewCatalogSelectionEnabled?: boolean;
  isUpdatingNextBillDateDisabled?: boolean;
  isV2DesignEnabled?: boolean;
  isExpandedForLineItem?: boolean;
}) => {
  const cloudSiteNode = !cloudSite ? <NewCloudSiteLozenge /> : cloudSite;

  const orgNode = (
    <>
      <OfficeBuildingFilledIcon label="" /> {orgName}
    </>
  );

  let cloudSiteOrOrgNode;
  if (!isEmpty(orgName)) {
    cloudSiteOrOrgNode = orgNode;
  } else if (!cloudSite) {
    cloudSiteOrOrgNode = <NewCloudSiteLozenge />;
  } else {
    cloudSiteOrOrgNode = cloudSite;
  }

  const heading = (
    <div className="product-line-items-wrapper--heading flex align-center justify-space-between">
      <div className="product-line-items-wrapper--cloudsite flex">{cloudSiteOrOrgNode}</div>
      <div className="product-line-items-wrapper--heading-buttons flex align-center">
        {isEmpty(orgName) && (
          <AddNewProductsWrapper
            cloudSiteHost={cloudSite}
            cloudSiteId={cloudSiteId as string}
            isNetNewSite={isNetNewCatalogSelectionEnabled && !cloudSite}
          />
        )}
        {!isUpdatingNextBillDateDisabled && <NextBillDateWrapper cloudSiteHostname={cloudSite} />}
      </div>
    </div>
  );

  return (
    <CustomPanel
      heading={heading}
      toggleButtonPrefix={
        !selectiveCloudsiteRemovalEnable ? (
          <Button
            iconBefore={<CrossIcon size="small" label="expand-collapse" />}
            appearance="subtle"
            onClick={() => onRemoveCloudSiteClick(cloudSite)}
            className="product-line-items-wrapper--cross-button"
            testId="remove-cloudsite-button"
          />
        ) : (
          <></>
        )
      }
      toggleButtonOnLeft
      isDefaultExpanded={!cloudSite}
      noHoverBackground
      isCustomPanelV2Enabled={isV2DesignEnabled}
      {...(isExpandedForLineItem && { isCustomExpanded: isExpandedForLineItem })}
      customToggleTestId={`custom-panel-toggle-button-${cloudSite || orgName}`}
    >
      {/*NOTE: TTC-21162-Remove the textbox due to content is not ready yet*/}
      {/* {!cloudSite && <NewCloudSiteLozengeInfo />} */}
      {children}
    </CustomPanel>
  );
};
